const tutorialStyles = {
    options: {
        zIndex: 10000,
        primaryColor: '#2f5141',
        textColor: '#333',
        arrowColor: '#277618',
        backgroundColor: '#fff',
        overlayColor: 'rgba(0, 0, 0, 0.5)',
    },
    buttonNext: {
        backgroundColor: '#2f5141',
    },
    buttonBack: {
        color: '#277618',
    },
    buttonClose: {
        display: 'none',
    },
    tooltip: {
        borderRadius: '4px',
    },
};

export default tutorialStyles;
